import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter, inject,
  Input, OnChanges,
  Output, SimpleChanges,
} from '@angular/core';
import { TMenuItem } from '../x-menu/x-menu.component';
import { AsyncPipe, NgIf } from '@angular/common';
import { SvgIconComponent } from 'angular-svg-icon';
import { XDropdownWrapperComponent } from '../x-dropdown-wrapper/x-dropdown-wrapper.component';
import { XLabelPaddingComponent } from '../x-label-padding/x-label-padding.component';
import { XInnerInputComponent } from '../x-inner-input/x-inner-input.component';
import {
  MatAutocomplete,
  MatAutocompleteOrigin,
  MatAutocompleteSelectedEvent,
  MatAutocompleteTrigger,
  MatOption,
} from '@angular/material/autocomplete';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BehaviorSubject, map } from 'rxjs';

@Component({
  selector: 'app-x-autocomplete',
  standalone: true,
  imports: [
    NgIf,
    SvgIconComponent,
    XDropdownWrapperComponent,
    XLabelPaddingComponent,
    XInnerInputComponent,
    MatAutocomplete,
    MatAutocompleteOrigin,
    MatOption,
    MatAutocompleteTrigger,
    AsyncPipe,
    ReactiveFormsModule,
    FormsModule,
  ],
  templateUrl: './x-autocomplete.component.html',
  styleUrl: './x-autocomplete.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class XAutocompleteComponent implements OnChanges {
  private cdr = inject(ChangeDetectorRef);
  @Input() placeholder: string = '';
  @Input() selectedId: string = '';
  @Input() disabled: boolean = false;

  @Output() searchStringChange = new EventEmitter<string>();
  @Output() selectedIdChange = new EventEmitter<string>();

  @Input() options: TMenuItem[] | null = [];

  private _searchString$ = new BehaviorSubject<string>('');
  public filteredOptions$ = this._searchString$.pipe(
    map((filter) => {
      if (!this.options) {
        return [];
      }

      return this.options.filter((it) => it.text.toLowerCase().includes(filter.toLowerCase()));
    }),
  );

  public onOptionSelected(option: MatAutocompleteSelectedEvent) {
    const selectedOption = option.option;

    this.selectedId = selectedOption.id;
    this.selectedIdChange.emit(this.selectedId);
  }

  public onInputValueChange(newVal: string | null | undefined) {
    const safeValue = newVal ?? '';
    this._searchString$.next(safeValue);

    this.searchStringChange.next(safeValue);
  }

  private isNeedToUpdateOptions = false;
  public onInputBlur() {
    this.isNeedToUpdateOptions = true;
  }

  public tryUpdateOptions() {
    if (this.isNeedToUpdateOptions) {
      setTimeout(() => {
        this.onInputValueChange('');
        this.cdr.markForCheck();
      }, 600);
      this.isNeedToUpdateOptions = false;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    const optionsChange = changes['options'];

    if (optionsChange) {
      if (optionsChange.previousValue !== optionsChange.currentValue) {
        this._searchString$.next('');
      }
    }
  }
}
